import React, { useEffect, useState, useContext } from "react";
import "./meaplanPopupData.scss";
import UserContext from "../../../../services/context/userContext";
import Plans from "../../../../components/_mealplans/Plans";
import generateUnique from "../../../../services/defaultFunctions/generateUnique";
import Button from "../../../../components/_default/Button";
import Popup from "../../../../components/_default/Popup";
import DropDown from "../../../_default/DropDown";
import { addMacros, addMealplanClient, getMacrosData } from "../../../../services/firebase/firestore/saveData";
import { getMealplansCoach, getMealplansAurum, getMealplanFromClient, getUserById, getCLientById, getLatestProgress } from "../../../../services/firebase/firestore/getData";
import Input from "../../../_default/Input";
import { Rating } from "semantic-ui-react";
import ReactDropdown from "react-dropdown";
import moment from "moment";
import { useParams } from "react-router-dom";
import Loading from "../../../_default/Loading";
// import { Dropdown as SemanticDrop } from "semantic-ui-react";
// import {Dropdown as GenderDropdown}   from "../../../../components/_default/DropDown";

import { IoMdAddCircle } from "react-icons/io"
import { AiFillMinusCircle } from "react-icons/ai"
import { FaMinusCircle } from "react-icons/fa";
import TDDEECalculator from "../../../TDDECalculator";
import UpdatedTDDE from "../../../TDDECalculator/UpdatedTDDE";

export default function MealplanPopupData({ selected_client,button, onCancel, savePopup, client_id, time }) {
  console.log("selected_client",selected_client)
  localStorage.removeItem("tabIndex")
  const user = useContext(UserContext);
  const isAdmin = (true);
  const [loading, setLoading] = useState(false);
  const [loadingDuplicate, setLoadingDuplicate] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [error, setError] = useState(false);
  const [filterName, setFilterName] = useState(false);
  const [filter, setFilter] = useState(false);
  const [updateData, setUpdateData] = useState(false);
  const [allMealplans, setAllMealPlans] = useState(false);
  const [client, setClient] = useState(false);
  const [weightCurrent, setWeightCurrent] = useState(false);

  const [totalCalories, setTotalCalories] = useState({
    protein: 0, fats: 0, carbs: 0, alcohol: 0, fiber: 0, calories: 0
  });

  // Sedentary (little or no exercise)
  // Lightly Active (light activities 1-3 days/week)
  // Moderately Active (moderate activities 3-5 days/week)
  // Very Active (high intensity activities 6-7 day/week)
  // Extra Active or Athletes (very demanding activities, physical job or 2x day workouts)


  const [activityFactors, setActivityFactors] = useState([
    '1.2: Sedentary (little or no exercise)',
    '1.375: Lightly Active (light activities 1-3 days/week)',
    '1.55: Moderately Active (moderate activities 3-5 days/week)',
    '1.725: Very Active (high intensity activities 6-7 day/week)',
    '1.9: Extra Active or Athletes (very demanding activities, physical job or 2x day workouts)',
  ]);
  const [activityFactorsText, setActivityFactorsText] = useState([
    'Sedentary (little or no exercise)',
    'Lightly Active (light activities 1-3 days/week)',
    'Moderately Active (moderate activities 3-5 days/week)',
    'Very Active (high intensity activities 6-7 day/week)',
    'Extra Active or Athletes (very demanding activities, physical job or 2x day workouts)',
  ]);

  const [genderDrop, setGenderDrop] = useState(["Male", "Female"])
  const [chooseGender, setChooseGender] = useState("Male")
  let [proteinSlider, setProtienSlider] = useState(0.0)
  let [calInfoSlider, setCaloInfoSlider] = useState(0)
  let [kCal, setKcal] = useState(0)
  const [choosedFactor, setChoosedFactor] = useState('Select activity');
  const [calculated, setCalculated] = useState(false);
  const [fat, setFat] = useState(false);

  let [fatSlider, setFatSlider] = useState(0.0)
  const [calFat, setCalFat] = useState(0);
  const [calProtein, setCalProtein] = useState(0);
  const [calFiber, setCalFiber] = useState(0);
  const [calCarbohydrates, setCalCarbohydrates] = useState(0);
  const [calAlcohol, setCalAlcohol] = useState(0);
  const [showCalculator, setShowCalculator] = useState(false);
  let [protienPerDay, setProtienPerDay] = useState(0)
  let [fatTDEE, setFatTDEE] = useState(0)
  let [carbohaydratePercentCal, setCarboHyderatePercentCal] = useState(0)
  let [carbohaydratePerDay, setCarboHyderatePerDay] = useState(0)
  let [leanBodyMass, setLeanBodyMass] = useState(0)
  let [proteinLeanMass, setProteinLeanMass] = useState(0.0)
  let [proteinCaloriesPerDay, setProteinCaloriesPerDay] = useState(0)
  let [fatCalories, setFatCalories] = useState(0.00)
  let [weight, setWeight] = useState("")
  let [height, setHeight] = useState("")
  let [age, setAge] = useState("")
  let [clientData,setClientData]=useState({})

  let { id } = useParams()
  // console.log("id", id)
  
  // let weight = 45;
  // let height = 155;
  // let age = 22;
  const [plan, set_plan] = useState([
    {
      food: [
        {
          mealplan_id: "",
          name: "",
          protein: 0,
          fats: 0,
          carbs: 0,
          alcohol: 0,
          fiber: 0,
          calories: 0,
          quantity: 100,
          eaten: false,
          thumbnail: ""
        },
      ],
      id: "8796-8897a",
      name: "",
    },
  ]);

  useEffect(() => {
    let date = new Date()
    let todaydate = moment().format("YYYY-MM-DD")
    // console.log("dateddsd",moment().format("YYYY-MM-DD"))
    getMacrosData(id, todaydate, result => {
      // console.log("result", result)
      if (result) {

        setLoading(false)
        setChoosedFactor(result.activity)
        setFat(result.bodyfat)
        setCaloInfoSlider(result.calories)
        setCarboHyderatePerDay(result.carbsPerDay)
        setCarboHyderatePercentCal(result.carbsCalories)
        setFatSlider(result.fat)
        setFatCalories(result.fatCalories)
        setFatTDEE(result.fatPerDay)
        setLeanBodyMass(result.leanBodyMass)
        setProtienSlider(result.protein)
        setProteinLeanMass(result.proteinLean)
        setProteinCaloriesPerDay(result.proteinCalories)
        setProtienPerDay(result.proteinPerDay)
        // setCaloInfoSlider(parseFloat(result.calories).toFixed(2))
        // setProtienPerDay(result.proteinGramPerDay)
        // setProteinCaloriesPerDay(parseFloat(result.proteinCaloriesPerDay))
        // setFatTDEE(parseFloat(result.fatGramPerDayValue).toFixed(2))
        // setFatCalories(parseFloat(result.fatCaloriesPerDay).toFixed(2))
        // setCarboHyderatePerDay(parseFloat(result.carbsGramPerDay).toFixed(2))
        // setCarboHyderatePercentCal(parseFloat(result.carbsCalories).toFixed(2))
      } else {
        setLoading(false)
      }
    })
  }, [])



  useEffect(() => {
    //protein per day
    let tenPercentOfTotal = (calInfoSlider / 10)
    let thirtyFiveOfTotal = (calInfoSlider / 35)
    // let result = tenPercentOfTotal - thirtyFiveOfTotal
    let result,protCal;
    // console.log("result", result, tenPercentOfTotal, thirtyFiveOfTotal)
    if (leanBodyMass && proteinLeanMass) {
      result = leanBodyMass * proteinLeanMass
      setProtienPerDay(result)
      protCal = 4 * result
      setProteinCaloriesPerDay(protCal)
    } else {
      result = proteinSlider * parseInt(weight)
      setProtienPerDay(result)
      protCal = 4 * result
      setProteinCaloriesPerDay(protCal)
    }

    let fat;
    let fatCalo;
    if (parseInt(weight)) {
      fat = (weight * fatSlider);
      fatCalo = (9 * fat);
      setFatTDEE(fat);
      setFatCalories(fatCalo)
    } else {
      fat = fatSlider * leanBodyMass
      fatCalo = (9 * fat);
      setFatTDEE(fat)
      setFatCalories(fatCalo)
    }

    let carbo;
    // console.log("fatsss", fatCalories,fat,)
    carbo = (calInfoSlider- (protCal + fatCalo))
    setCarboHyderatePercentCal(carbo.toFixed(2))
    let perDayCarbo = (carbo / 4)
    setCarboHyderatePerDay(perDayCarbo.toFixed(2))
  }, [calInfoSlider, leanBodyMass, proteinSlider, proteinLeanMass, fatSlider, chooseGender, weight, height])
  const handleChangeProtienSlider = (e) => {
    // proteinSlider++
    if (proteinLeanMass > 0) {
      setProteinLeanMass(0)
      setLeanBodyMass("lean body mass")
      setProtienSlider(e.target.value)
    } else {

      setProtienSlider(e.target.value)
    }

  }
  const handleFatSlider = (e) => {
    // let date=new Date()
    // date.getDate(dob.setSeconds(945216000)
    setFatSlider(e.target.value)
  }
  const handleChangeCalSlider = (e) => {
    setCaloInfoSlider(e.target.value)

  }
  let handleLeanBodyMass = (e) => {
    let manCalMassForm = (((0.32810 * weight) + (0.33929 * height)) - 29.5336)
  }
  let handleProteinLeanMass = (e) => {
    // setProteinLeanMass(e.target.value)
    if (proteinSlider > 0) {
      setProtienSlider(0)
      setProteinLeanMass(e.target.value)
    } else {
      setProteinLeanMass(e.target.value)

    }
  }

  const handleChoosedFactor = (e) => {
    let factor = e
    setChoosedFactor(factor)
    let calFormula
    if (chooseGender == "Male") {
      // calFormula = (((((10 * parseInt(weight)) + (6.25 * parseInt(height))) - (5 * parseInt(age))) + 5))
      calFormula=(66.5 + 13.75 * parseFloat(weight) + 5.003 * parseFloat(height) - 6.755 * parseFloat(age))
      if (e === "Sedentary (little or no exercise)") {
        let result = calFormula * 1.2
        setCaloInfoSlider(result.toFixed(2))

      } else if (e === "Lightly Active (light activities 1-3 days/week)") {
        let result = calFormula * 1.375
        setCaloInfoSlider(result.toFixed(2))

      }
      else if (e === "Moderately Active (moderate activities 3-5 days/week)") {
        let result = calFormula * 1.55
        setCaloInfoSlider(result)

      }
      else if (e === "Very Active (high intensity activities 6-7 day/week)") {
        let result = calFormula * 1.725
        setCaloInfoSlider(result.toFixed(2))

      }
      else if (e === "Extra Active or Athletes (very demanding activities, physical job or 2x day workouts)") {
        let result = calFormula * 1.9
        setCaloInfoSlider(result.toFixed(2))

      }
    } else {
      // calFormula = (((((10 * parseInt(weight)) + (6.25 * parseInt(height))) - (5 * parseInt(age))) + 161))
      calFormula=(655 + 9.563 * parseFloat(weight) + 1.85 * parseFloat(height) - 4.676 * parseFloat(age))
      if (e === "Sedentary (little or no exercise)") {
        let result = calFormula * 1.2
        setCaloInfoSlider(result.toFixed(2))

      } else if (e === "Lightly Active (light activities 1-3 days/week)") {
        let result = calFormula * 1.375
        setCaloInfoSlider(result.toFixed(2))

      }
      else if (e === "Moderately Active (moderate activities 3-5 days/week)") {
        let result = calFormula * 1.55
        setCaloInfoSlider(result)

      }
      else if (e === "Very Active (high intensity activities 6-7 day/week)") {
        let result = calFormula * 1.725
        setCaloInfoSlider(result.toFixed(2))

      }
      else if (e=== "Extra Active or Athletes (very demanding activities, physical job or 2x day workouts)") {
        let result = calFormula * 1.9
        setCaloInfoSlider(result.toFixed(2))

      }
    }

  }
  useEffect(() => {
    let __factor = 0; let __fact = '';
    activityFactors.forEach(element => {
      if (element.includes(choosedFactor)) {
        __fact = element;
      }

    });
    __factor = parseFloat(__fact.substr(0, __fact.indexOf(':')));
    let __weight = parseFloat(client?.measurements?.weight.replace(',', '.'));
    let __fat = parseFloat(fat);
    setCalculated(
      __factor * (370 + ((21.6 * (__weight - __fat))))
    )
  }, [choosedFactor, fat])

  useEffect(() => {


    getCLientById(client_id, callback => {
      setClient(callback);
      setClientData(callback)
      // console.log("callback client", callback);
      setChooseGender(callback.gender)
      setHeight(callback.measurements.length)
      setWeight(callback.measurements.weight)
      // console.log("age",moment().diff(callback.date_of_birth.toDate(),"years"))
      setAge(moment().diff(callback.date_of_birth.toDate(), "years"))

    })
    getLatestProgress(client_id, callback => {
      setWeightCurrent(parseFloat(callback.weight));
      // console.log("callback measuremnets", callback)
      setFat(parseFloat(callback.bodyfat));
    })


  }, [client_id, weight, height,client])

  useEffect(() => {
    if (updateData) {
      let _mealplan = updateData;
      let data = {
        food: [
          {
            mealplan_id: "",
            name: "",
            protein: 0,
            fats: 0,
            carbs: 0,
            alcohol: 0,
            fiber: 0,
            calories: 0,
            quantity: 100,
            eaten: false,
            thumbnail: ""
          },
        ],
        id: "8796-8897a",
        name: ""
      };
      let completeData = [];

      let foodItems = _mealplan.plan;
      foodItems.forEach(element => {
        let counter = 0;
        let singleItem = element.food;
        singleItem.forEach(item => {

          if (counter > 0) {
            data.food.push({
              mealplan_id: "",
              name: "",
              protein: 0,
              fats: 0,
              carbs: 0,
              alcohol: 0,
              fiber: 0,
              calories: 0,
              quantity: 100,
              eaten: false,
              thumbnail: ""
            })
          }

          data.food[counter].name = item.name;
          data.food[counter].protein = item.protein;
          data.food[counter].fats = item.fats;
          data.food[counter].carbs = item.carbs;
          data.food[counter].alcohol = item.alcohol;
          data.food[counter].fiber = item.fiber;
          data.food[counter].calories = item.calories;
          data.food[counter].quantity = item.quantity;
          data.food[counter].eaten = item?.eaten ? item.eaten : false;
          data.food[counter].thumbnail = item?.thumbnail ? item.thumbnail : "";

          counter++;
        });
        data.name = element.name;
        data.id = element.name;

        completeData.push(data);

        // reset data for next time going through loop
        data = {
          food: [
            {
              mealplan_id: "",
              name: "",
              protein: 0,
              fats: 0,
              carbs: 0,
              alcohol: 0,
              fiber: 0,
              calories: 0,
              quantity: 100,
              eaten: false,
              thumbnail: ""
            },
          ],
          id: "8796-8897a",
          name: ""
        };
      });

      set_plan(completeData);

      setLoadingDuplicate(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      set_plan([
        {
          food: [
            {
              mealplan_id: "",
              name: "",
              protein: 0,
              fats: 0,
              carbs: 0,
              alcohol: 0,
              fiber: 0,
              calories: 0,
              quantity: 100,
              eaten: false,
              thumbnail: ""
            },
          ],
          id: "8796-8897a",
          name: "",
        },
      ]);
    }
  }, [updateData]);

  useEffect(() => {
    let _calories = { protein: 0, fats: 0, carbs: 0, alcohol: 0, fiber: 0, calories: 0 };
    plan.forEach(food => {
      food.food.forEach(nutrient => {
        _calories.protein = _calories.protein + parseFloat(nutrient.protein);
        _calories.fats = _calories.fats + parseFloat(nutrient.fats);
        _calories.carbs = _calories.carbs + parseFloat(nutrient.carbs);
        _calories.alcohol = _calories.alcohol + parseFloat(nutrient.alcohol);
        _calories.fiber = _calories.fiber + parseFloat(nutrient.fiber);
        _calories.calories = _calories.calories + parseFloat(nutrient.calories);
      });
    });
    setTotalCalories(_calories);
  }, [plan])

  function addFood(idx) {
    let _plan = [...plan];
    _plan[idx].food.push({
      mealplan_id: generateUnique(1, 9),
      name: "",
      protein: 0,
      fats: 0,
      carbs: 0,
      alcohol: 0,
      fiber: 0,
      calories: 0,
      quantity: 100,
    });
    set_plan(_plan);
  }

  function onDragEnd(result) {
    const { destination, source, type, draggableId } = result;
    let new_plan = plan;

    if (!result.destination) {
      return;
    }
    switch (type) {
      case "parent":
        new_plan = reorder(plan, source.index, destination.index);
        break;
      case "child":
        new_plan = reorderChild(plan, source, destination);
        break;
      default:
        break;
    }
    set_plan(new_plan);
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);

    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const reorderChild = (list, start, end) => {
    const result = Array.from(list);

    const parent_start_index = result.findIndex((e) => e.id === start.droppableId);
    const parent_end_index = result.findIndex((e) => e.id === end.droppableId);
    const [removed] = result[parent_start_index].food.splice(start.index, 1);
    result[parent_end_index].food.splice(end.index, 0, removed);

    return result;
  };

  function onChange(e, type, food_idx, set_idx) {
    let _plan = [...plan];
    if (type === "add_food") {
      _plan[set_idx].food[food_idx].name = e.product_name;
      _plan[set_idx].food[food_idx].protein = parseFloat(e.nutriments.proteins_100g ? (e.nutriments.proteins_100g / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
      _plan[set_idx].food[food_idx].fats = parseFloat(e.nutriments.fat_100g ? (e.nutriments.fat_100g / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
      _plan[set_idx].food[food_idx].carbs = parseFloat(e.nutriments.carbohydrates_100g ? (e.nutriments.carbohydrates_100g / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
      _plan[set_idx].food[food_idx].alcohol = parseFloat(e.nutriments.alcohol_100g ? (e.nutriments.alcohol_100g / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
      _plan[set_idx].food[food_idx].fiber = parseFloat(e.nutriments.fiber_100g ? (e.nutriments.fiber_100g / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
      _plan[set_idx].food[food_idx].calories = parseFloat(e.nutriments["energy-kcal_100g"] ? (e.nutriments["energy-kcal_100g"] / 100) * _plan[set_idx].food[food_idx].quantity : 0).toFixed(2);
      _plan[set_idx].food[food_idx].thumbnail = e.image_front_thumb_url;
    }
    if (type === "quantity") {
      debugger
      console.log("quantity")
      _plan[set_idx].food[food_idx].protein = parseFloat((_plan[set_idx].food[food_idx].protein / _plan[set_idx].food[food_idx].quantity) * parseFloat(e > 0 ? e : "")).toFixed(2);
      _plan[set_idx].food[food_idx].fats = parseFloat((_plan[set_idx].food[food_idx].fats / _plan[set_idx].food[food_idx].quantity) * parseFloat(e > 0 ? e : 1)).toFixed(2);
      _plan[set_idx].food[food_idx].carbs = parseFloat((_plan[set_idx].food[food_idx].carbs / _plan[set_idx].food[food_idx].quantity) * parseFloat(e > 0 ? e : 1)).toFixed(2);
      _plan[set_idx].food[food_idx].alcohol = parseFloat((_plan[set_idx].food[food_idx].alcohol / _plan[set_idx].food[food_idx].quantity) * parseFloat(e > 0 ? e : 1)).toFixed(2);
      _plan[set_idx].food[food_idx].fiber = parseFloat((_plan[set_idx].food[food_idx].fiber / _plan[set_idx].food[food_idx].quantity) * parseFloat(e > 0 ? e : 1)).toFixed(2);
      _plan[set_idx].food[food_idx].calories = parseFloat((_plan[set_idx].food[food_idx].calories / _plan[set_idx].food[food_idx].quantity) * parseFloat(e > 0 ? e : 1)).toFixed(2);
      _plan[set_idx].food[food_idx][type] = e > 0 ? e : 1;
      // _plan[set_idx].food[food_idx][type] = e > 0 ? e : "";
    } else {
      if (food_idx !== false) {
        _plan[set_idx].food[food_idx][type] = e;
      } else {
        _plan[set_idx][type] = e;
      }
    }

    set_plan(_plan);
  }

  function addSet() {
    let _plan = [...plan];
    _plan.push({
      food: [
        {
          mealplan_id: generateUnique(1, 9),
          name: "",
          protein: 0,
          fats: 0,
          carbs: 0,
          alcohol: 0,
          fiber: 0,
          calories: 0,
          quantity: 100,
        },
      ],
      id: generateUnique(1, 9),
      name: "",
      rest_time_in_minutes: 0,
    });
    set_plan(_plan);
  }

  function onSubmit(duplicate) {
    // debugger
    setLoading(true)
    let _empty_plan_name = plan.findIndex((e) => e.name === "");
    let _empty_food_in_plan = plan.findIndex((e) => e.food.length <= 0);

    if (_empty_plan_name >= 0) {
      setError({ type: "plan_name", message: "Add a name for your meal.", idx: _empty_plan_name });
    } else if (_empty_food_in_plan >= 0) {
      setError({ type: "plan_name", message: "Add at least one nutrient.", idx: _empty_food_in_plan });
    } else {
      setError(false);
      const _mealplan = {
        plan: plan
      };
      // add to db
      addMealplanClient(client_id, _mealplan, time, (result) => {
        onCancel();
      })

    }

    let content = {
      protein: proteinSlider,
      proteinLean: proteinLeanMass,
      proteinPerDay: protienPerDay,
      proteinCalories: proteinCaloriesPerDay,
      fat: fatSlider,
      fatPerDay: fatTDEE,
      fatCalories: fatCalories,
      carbsPerDay: carbohaydratePerDay,
      carbsCalories: carbohaydratePercentCal,
      age: age,
      weight: weight,
      height: height,
      calories: calInfoSlider,
      activity: choosedFactor,
      bodyfat: fat,
      leanBodyMass: leanBodyMass || 0


      // proteinGramPerDay:protienPerDay,
      // proteinCaloriesPerDay:proteinCaloriesPerDay,
      // fatGramPerDayValue:fatTDEE,
      // fatCaloriesPerDay:fatCalories,
      // calories:calInfoSlider,
      // carbsGramPerDay:carbohaydratePerDay,
      // carbsCalories:carbohaydratePercentCal
    }
    let todatyDate = new Date()
    let date = moment(todatyDate).format("YYYY-MM-DD")
    // console.log("ddddd",moment(todatyDate).format("YYYY-MM-DD"))
    addMacros(id, date, content, e => {
      // setLoading(false);

      // console.log("eeeee", e)
      setProteinCaloriesPerDay(0.0)
      setProteinLeanMass(0.0)
      setProtienSlider(0)
      setProtienPerDay(0.0)
      setFatTDEE(0.0)
      setCaloInfoSlider(0)
      setFatSlider(0)
      setFatCalories(0.0)
      setCarboHyderatePercentCal(0.0)
      setCarboHyderatePerDay(0.0)
      setActivityFactors("Sedentary (little or no exercise")
      setLoading(false)

      // navigation.goBack();
    });
    // addMacros(id,content)
  }

  function removeSet(set_idx) {
    let _plan = [...plan];
    switch (showPopup.type) {
      case "set":
        _plan.splice(set_idx, 1);
        break;
      case "mealplan":
        _plan[showPopup.set_idx].food.splice(showPopup.mealplan_idx, 1);
        break;

      default:
        break;
    }

    set_plan(_plan);
    setShowPopup(false);
  }

  function removeSetClick(e) {
    let myDiv = document.querySelector('.c-page-wrapper-mealplan');
    myDiv.scrollTo(0, 0);
    setShowPopup({ type: "set", id: e });
  }

  function removeExerciseClick(mealplan_idx, set_idx) {
    let myDiv = document.querySelector('.c-page-wrapper-mealplan');
    myDiv.scrollTo(0, 0);
    setShowPopup({ type: "mealplan", mealplan_idx: mealplan_idx, set_idx: set_idx });
  }

  useEffect(() => {
    getMealPlan('custom');
    let allMealplans = [];
    getMealplansCoach(user.id, (result) => {
      let mealplans = ["custom"];
      mealplans.push({
        type: 'group', name: 'Coach', items: [

        ]
      })
      result && result.forEach(element => {
        mealplans[1].items.push(element.name);
        allMealplans.push(element)
      });
      mealplans.push({
        type: 'group', name: 'Aurum', items: [

        ]
      })
      getMealplansAurum((result) => {
        result && result.forEach(element => {
          mealplans[2].items.push(element.name);
          allMealplans.push(element)
        });
      })

      setAllMealPlans(allMealplans);
      setFilterName(mealplans);
    })
  }, [user]);

  function getMealPlan(e) {
    if (e != "custom") {
      let meal = allMealplans.find(x => x.name === e)
      setUpdateData(meal);
    } else {
      // check if there is one in db for user
      getMealplanFromClient(client_id, time, (result) => {
        if (result) {
          setUpdateData(result);
        } else {
          setUpdateData(false);
        }
      })
    }
  }

  function toggleCalculator() {
    if (showCalculator) {
      setShowCalculator(false);
    } else {
      setShowCalculator(true);
    }

    //   const [showCalculator, setShowCalculator] = useState(false);
  }

  const handleBodyFat=(e)=>{
    setFat(e)
    console.log("fat value",e)
    const bodyFatPer = weight * (parseInt(e) / 100);
    const leanMass = parseFloat(weight - bodyFatPer);
    setLeanBodyMass(leanMass)
    // let factor = e
    // setChoosedFactor(factor)
    let calFormula
    if (chooseGender == "Male") {
      calFormula = (((((10 * parseInt(leanMass?leanMass:weight)) + (6.25 * parseInt(height))) - (5 * parseInt(age))) + 5))
      if (choosedFactor === "Sedentary (little or no exercise)") {
        let result = calFormula * 1.2
        setCaloInfoSlider(result.toFixed(2))

      } else if (choosedFactor === "Lightly Active (light activities 1-3 days/week)") {
        let result = calFormula * 1.375
        setCaloInfoSlider(result.toFixed(2))

      }
      else if (choosedFactor === "Moderately Active (moderate activities 3-5 days/week)") {
        let result = calFormula * 1.55
        setCaloInfoSlider(result)

      }
      else if (choosedFactor === "Very Active (high intensity activities 6-7 day/week)") {
        let result = calFormula * 1.725
        setCaloInfoSlider(result.toFixed(2))

      }
      else if (choosedFactor === "Extra Active or Athletes (very demanding activities, physical job or 2x day workouts)") {
        let result = calFormula * 1.9
        setCaloInfoSlider(result.toFixed(2))

      }
    } else {
      calFormula = (((((10 * parseInt(leanMass?leanMass:weight)) + (6.25 * parseInt(height))) - (5 * parseInt(age))) + 161))
      if (choosedFactor === "Sedentary (little or no exercise)") {
        let result = calFormula * 1.2
        setCaloInfoSlider(result.toFixed(2))

      } else if (choosedFactor === "Lightly Active (light activities 1-3 days/week)") {
        let result = calFormula * 1.375
        setCaloInfoSlider(result.toFixed(2))

      }
      else if (choosedFactor === "Moderately Active (moderate activities 3-5 days/week)") {
        let result = calFormula * 1.55
        setCaloInfoSlider(result)

      }
      else if (choosedFactor === "Very Active (high intensity activities 6-7 day/week)") {
        let result = calFormula * 1.725
        setCaloInfoSlider(result.toFixed(2))

      }
      else if (choosedFactor === "Extra Active or Athletes (very demanding activities, physical job or 2x day workouts)") {
        let result = calFormula * 1.9
        setCaloInfoSlider(result.toFixed(2))

      }
    }
  }
  useEffect(()=>{
    let leanMass;
    if(fat){
      // setFat(e)
      console.log("fat value",fat)
      const bodyFatPer = weight * (parseInt(fat) / 100);
       leanMass = parseFloat(weight - bodyFatPer);
      setLeanBodyMass(leanMass)
      // let factor = e
      // setChoosedFactor(factor)
      let calFormula
      if (chooseGender == "Male") {
        // calFormula = (((((10 * parseInt(leanMass?leanMass:weight)) + (6.25 * parseInt(height))) - (5 * parseInt(age))) + 5))
        calFormula=(66.5 + 13.75 * parseFloat(leanMass?leanMass:weight) + 5.003 * parseFloat(height) - 6.755 * parseFloat(age))
        if (choosedFactor === "Sedentary (little or no exercise)") {
          let result = calFormula * 1.2
          setCaloInfoSlider(result.toFixed(2))
  
        } else if (choosedFactor === "Lightly Active (light activities 1-3 days/week)") {
          let result = calFormula * 1.375
          setCaloInfoSlider(result.toFixed(2))
  
        }
        else if (choosedFactor === "Moderately Active (moderate activities 3-5 days/week)") {
          let result = calFormula * 1.55
          setCaloInfoSlider(result)
  
        }
        else if (choosedFactor === "Very Active (high intensity activities 6-7 day/week)") {
          let result = calFormula * 1.725
          setCaloInfoSlider(result.toFixed(2))
  
        }
        else if (choosedFactor === "Extra Active or Athletes (very demanding activities, physical job or 2x day workouts)") {
          let result = calFormula * 1.9
          setCaloInfoSlider(result.toFixed(2))
  
        }
      } else {
        // calFormula = (((((10 * parseInt(leanMass?leanMass:weight)) + (6.25 * parseInt(height))) - (5 * parseInt(age))) + 161))
        calFormula=(655 + 9.563 * parseFloat(leanMass?leanMass:weight) + 1.85 * parseFloat(height) - 4.676 * parseFloat(age))
        if (choosedFactor === "Sedentary (little or no exercise)") {
          let result = calFormula * 1.2
          setCaloInfoSlider(result.toFixed(2))
  
        } else if (choosedFactor === "Lightly Active (light activities 1-3 days/week)") {
          let result = calFormula * 1.375
          setCaloInfoSlider(result.toFixed(2))
  
        }
        else if (choosedFactor === "Moderately Active (moderate activities 3-5 days/week)") {
          let result = calFormula * 1.55
          setCaloInfoSlider(result)
  
        }
        else if (choosedFactor === "Very Active (high intensity activities 6-7 day/week)") {
          let result = calFormula * 1.725
          setCaloInfoSlider(result.toFixed(2))
  
        }
        else if (choosedFactor === "Extra Active or Athletes (very demanding activities, physical job or 2x day workouts)") {
          let result = calFormula * 1.9
          setCaloInfoSlider(result.toFixed(2))
  
        }
      }
    }
    else{
      setFat(0)
      setLeanBodyMass(0.0)
      // let factor = e
      // setChoosedFactor(factor)
      let calFormula
      if (chooseGender == "Male") {
        // calFormula = (((((10 * parseInt(weight)) + (6.25 * parseInt(height))) - (5 * parseInt(age))) + 5))
        calFormula=(66.5 + 13.75 * parseFloat(leanMass? leanMass : weight) + 5.003 * parseFloat(height) - 6.755 * parseFloat(age))
        if (choosedFactor === "Sedentary (little or no exercise)") {
          let result = calFormula * 1.2
          setCaloInfoSlider(result.toFixed(2))
    
        } else if (choosedFactor === "Lightly Active (light activities 1-3 days/week)") {
          let result = calFormula * 1.375
          setCaloInfoSlider(result.toFixed(2))
    
        }
        else if (choosedFactor === "Moderately Active (moderate activities 3-5 days/week)") {
          let result = calFormula * 1.55
          setCaloInfoSlider(result)
    
        }
        else if (choosedFactor === "Very Active (high intensity activities 6-7 day/week)") {
          let result = calFormula * 1.725
          setCaloInfoSlider(result.toFixed(2))
    
        }
        else if (choosedFactor === "Extra Active or Athletes (very demanding activities, physical job or 2x day workouts)") {
          let result = calFormula * 1.9
          setCaloInfoSlider(result.toFixed(2))
    
        }
      } else {
        // calFormula = (((((10 * parseInt(weight)) + (6.25 * parseInt(height))) - (5 * parseInt(age))) + 161))
        calFormula=(655 + 9.563 * parseFloat(leanMass?leanMass : weight) + 1.85 * parseFloat(height) - 4.676 * parseFloat(age))
        if (choosedFactor === "Sedentary (little or no exercise)") {
          let result = calFormula * 1.2
          setCaloInfoSlider(result.toFixed(2))
    
        } else if (choosedFactor === "Lightly Active (light activities 1-3 days/week)") {
          let result = calFormula * 1.375
          setCaloInfoSlider(result.toFixed(2))
    
        }
        else if (choosedFactor === "Moderately Active (moderate activities 3-5 days/week)") {
          let result = calFormula * 1.55
          setCaloInfoSlider(result)
    
        }
        else if (choosedFactor === "Very Active (high intensity activities 6-7 day/week)") {
          let result = calFormula * 1.725
          setCaloInfoSlider(result.toFixed(2))
    
        }
        else if (choosedFactor === "Extra Active or Athletes (very demanding activities, physical job or 2x day workouts)") {
          let result = calFormula * 1.9
          setCaloInfoSlider(result.toFixed(2))
    
        }
      }
    }
    
  
  }, [weight,leanBodyMass,fat])

  return (
    <>
      {
        loading ?
          <div>
            <Loading />
          </div> :
          <>
            <div className="c-page-wrapper c-page-wrapper-mealplan">

              <div style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
                <div className="c-popup-dropdown-container">
                  <h3 className="c-mealplan-popdata-titel">Select mealplan to autofillx</h3>
                  <DropDown options={filterName ? filterName : []} value={filter} onChange={(e) => { setFilter(e); getMealPlan(e) }} />
                </div>
                <button className="btn-calculator c-add-content-btn" style={{ backgroundColor: "#2F727C", marginBottom: '20px' }} onClick={() => toggleCalculator()}>
                  {/* Calorie calculator */}
                  TDEE calculator
                </button>
                {showCalculator ? (
                   
                    client?
                    ""
                    // <TDDEECalculator selectedClient={client} id={client.id}  />
                    // <UpdatedTDDE selectedClient={client} id={client.id} />
                    :""
                  
                ) : <></>}
                <div class="table-calories">
                  <h2>Calories : {Math.round(totalCalories.calories * 100) / 100}</h2>
                  <table bgcolor="#FFF" width="100%" align="left" cellspacing="10">
                    <tr align="left">
                      <th width="20%">Protein</th>
                      <th width="20%">Fat</th>
                      <th width="20%">Carbohydrate</th>
                      <th width="20%">Alcohol</th>
                      <th width="20%">Fiber</th>
                    </tr>
                    <tr>
                      <td>{Math.round(totalCalories.protein * 100) / 100}</td>
                      <td>{Math.round(totalCalories.fats * 100) / 100}</td>
                      <td>{Math.round(totalCalories.carbs * 100) / 100}</td>
                      <td>{Math.round(totalCalories.alcohol * 100) / 100}</td>
                      <td>{Math.round(totalCalories.fiber * 100) / 100}</td>
                    </tr>
                  </table>
                </div>
                <div className="c-page-main c-define-page c-page-plans">
                  <Plans isAdmin={isAdmin} addFood={(idx) => addFood(idx)} plan={plan} set_plan={set_plan} onDragEnd={onDragEnd} removeSet={(e) => removeSetClick(e)} removeExercise={(mealplan_idx, set_idx) => removeExerciseClick(mealplan_idx, set_idx)} onChange={(e, type, food_idx, plan_idx) => onChange(e, type, food_idx, plan_idx)} error={error} />

                  <button className="c-add-content-btn" style={{ backgroundColor: "#2F727C", marginBottom: '20px' }} onClick={() => addSet()}>
                    Add Meal
                  </button>
                  {/* <button className="c-add-content-btn" style={{backgroundColor: "rgb(92, 171, 183)", marginBottom: '20px'}}>
                      Chage date
                  </button> */}
                  <div className="c-button-collection c-button-collection-largePopup">
                    <Button text={button} color="#fff" backgroundColor="#00BDA5" className={`c-close-btn ${savePopup ? "--save" : ""}`} onSubmit={() => onSubmit(false)} loading={loading} />
                    <button className="c-cancel-btn" onClick={() => onCancel()}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
             
            </div>
            {showPopup && (
              <Popup
                title={"Remove item"}
                button="Remove"
                deletePopup={true}
                description={"Are you sure you want to remove this item? This can not be undone."}
                onAction={() => removeSet(showPopup.id)}
                onCancel={() => {
                  setShowPopup(false);
                }}
              />
            )}
          </>
      }
    </>
  )
}